// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] || chunkId) + "-" + {"223":"61bed9aaf202e7daa921","351":"1f6164adfe3920c83957","678":"91e8e735e73235bf4551","682":"33bca8067cba7593a178","843":"d5004318fad1adc522d2"}[chunkId] + ".js";
};